// src/v2/hooks/useShiftSchedules.js
import { useState, useEffect, useCallback } from 'react';
import shiftScheduleService from '../services/shiftScheduleService';

export function useShiftSchedules(autoFetchAll = true) {
  const [allShifts, setAllShifts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const response = await shiftScheduleService.getAll();
      setAllShifts(response.data || []);
      setError(null);
    } catch (err) {
      setError("Failed to fetch all shift schedules");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  // CRUD: Create
  const createShift = async (payload) => {
    setLoading(true);
    try {
      await shiftScheduleService.create(payload);
      await fetchAll(); // Refresh lists
      return { success: true };
    } catch (err) {
      return { success: false, error: err };
    } finally {
      setLoading(false);
    }
  };

  // CRUD: Update
  const updateShift = async (id, payload) => {
    setLoading(true);
    try {
      await shiftScheduleService.update(id, payload);
      await fetchAll(); // Refresh lists
      return { success: true };
    } catch (err) {
      return { success: false, error: err };
    } finally {
      setLoading(false);
    }
  };

  // CRUD: Delete
  const deleteShift = async (id) => {
    setLoading(true);
    try {
      await shiftScheduleService.delete(id);
      await fetchAll(); // Refresh lists
      return { success: true };
    } catch (err) {
      return { success: false, error: err };
    } finally {
      setLoading(false);
    }
  };

  // Auto-fetch on mount
  useEffect(() => {
    if (autoFetchAll) {
      fetchAll();
    }
  }, [autoFetchAll, fetchAll]);

  return {
    allShifts,
    loading,
    error,
    fetchAll,
    createShift,
    updateShift,
    deleteShift
  };
}